// this components is used in few places
const HostingIpAddr = () => import('@/views/services/hosting/common/HostingIpAddr')
const HostingAddons = () => import('@/views/services/hosting/common/HostingAddonsView')
// const HostingWhmLaunch = () => import('./../components/Services/Hosting/Whm/WhmLaunch')

export {
  HostingIpAddr,
  HostingAddons,
  // HostingWhmLaunch
}
